import FloatingCard from '@components/v2/ui/FloatingCard/FloatingCard';
import { memo } from 'react';
import LangEnum from '../../lang/LangEnum';
import { PosTestIds } from '../../utils/testIds/Pos.testIds';
import PosForm from './components/PosForm';
import { PosContextProvider, usePosContext } from './contexts/Pos.context';

const PosInnerContainer = () => {
  const { isPosOpen, onClose } = usePosContext();

  return (
    <FloatingCard
      isOpen={isPosOpen}
      onClose={onClose}
      title={LangEnum.POS_TITLE}
      testId={PosTestIds.CONTAINER}
    >
      <PosForm />
    </FloatingCard>
  );
};

const PosContainer = () => (
  <PosContextProvider>
    <PosInnerContainer />
  </PosContextProvider>
);

export default memo(PosContainer);
